import Api from '@/services/Api'

export default {
  get(teacherId) {
    if (teacherId === undefined) {
      return Api().get('teachers');
    } else {
      return Api().get(`teachers/${teacherId}`);
    }
  },
  getInvitedTeachers() {
    return Api().get('admin/invitations');
  },
  invite(data) {
    return Api().post('teachers/invite', data);
  },
  deleteInvitation(inviteId) {
    return Api().delete(`admin/invitations/${inviteId}`);
  },
  getSchool() {
    return Api().get('admin/school');
  },
  resetJoinCode() {
    return Api().post('admin/resetJoinCode');
  }

}